import React from "react";
import LazyloadImage from "./LazyloadImage";

export default class NextUpImage extends React.Component {
  static defaultProps = {
    containerClassName: 'photo-next-up-container',
    desktopWidth: 76,
    desktopHeight: 76
  };

  render() {
    return <LazyloadImage {...this.props} imageClassName='next-up-image' lazy={true}/>
  }
}
